import React, { useEffect, useState } from 'react'
import BossDialog from '../../../components/BossDialog';
import { useTranslation } from '../../../locale/useTranslation';
import bossAIPng from '../../../img/BOSS-AI.png';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { ResponseTable } from './ResponseTable';
import ActionButton from '../../../framework/forms/helpercomponents/buttons/ActionButton';
import { toast } from 'react-toastify';
import { utility } from '../../../framework/utility/utilityProvider';
import { ApplicationConfigurationKeys, ENTITYNAME } from '../../../framework/constant/constant';
import * as API from '../../../framework/API/api';
import { MultiSelect } from '@progress/kendo-react-dropdowns';


const BossAssistantIcon = (props) => {

  const enableBossAI = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.EnableBossAI) ?? false;

  let onDataLoad = props.onDataLoad ?? (() => alert('BOSS AI clicked!'));
  let tooltip = props.tooltip ?? 'Boss AI';
  let popupTtle = props.popupTtle ?? 'Generate Meta Data';
  let iconSize = props.iconSize ?? '45px';
  let showLanguage = props.showLanguage ?? false;

  const lang = useTranslation();
  const [dataItem, setDataItem] = useState({});
  const [data, setData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [showMetaData, setShowMetaData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPop, setIsPop] = useState(false);
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    if (props.mediaEpisodeEntity?.Title && props.mediaEpisodeEntity?.Title.length != 0) {

      setDataItem({
        ...dataItem,
        Title: props.mediaEpisodeEntity.Title
      });
    }

  }, [props.mediaEpisodeEntity]);

  useEffect(() => {
    loadCombo();
  }, []);

  const loadCombo = async () => {
    const langRes = await API.getDataLookup(ENTITYNAME.Language, { query: ['Archive', '=', false] });
    setLanguages(langRes.data);

    if (props.mediaEpisodeEntity?.Title) {
      setDataItem({
        ...dataItem,
        Title: props.mediaEpisodeEntity.Title,
        Languages: langRes.data.filter((x) => x.Description == "English")
      });
    }
  }

  const onCloseForm = () => {
    setShowForm(false);
    setDataItem({});
  }

  const onChange = (e) => {
    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
  }

  const generateData = (title, show = false, isFirstTime = false) => {
    
    if (!show) setIsPop(true);
    setShowForm(true);
    setIsLoading(true);

    if (isFirstTime && (!title || title.length == 0)) {
      return;
    }

    if (!isFirstTime && show && (!title || title.length == 0)) {
      toast.info(lang.please_enter_title_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return;
    }

    //LOADING DATA TIMEOUT
    setTimeout(async () => {

      let payload = {
        title: title,
        languages: dataItem.Languages
      }
      let response = await onDataLoad(payload);
      console.log(response);
      if (response.success) {
        setData(response.data);
        setIsLoading(false);
      }
    }, 4000);

    //POP EFFECT TIMEOUT
    setTimeout(() => setIsPop(false), 300);
  }

  const onConfirm = () => {

    setIsLoading(false);
    onCloseForm();

    //SET META DATA
    props.setMetaData(data);

  }

  return (
    !enableBossAI ? <></> : <div style={props.style ?? {
      position: 'absolute',
      top: '15.2%',
      right: '1%',
      display: 'flex',
    }}>
      <button
        title={tooltip}
        onClick={() => generateData(dataItem.Title, false, true)}
        style={{
          borderRadius: '50%',
          border: 'none'
        }}
      >
        <img src={bossAIPng} alt="Boss AI" className={isPop ? 'popup-animate' : ''} style={{ width: iconSize, height: iconSize }} />
      </button>

      {
        showForm && <BossDialog
          title={`${popupTtle} ${dataItem.Title ? "- " + dataItem.Title : ''}`}
          showBossAIIcon={true}
          onClose={onCloseForm}
          width={"680px"}
        >

          <div className="row mb-3">
            <div className={showLanguage ? "col-5" : "col-10"}>
              <label htmlFor="">{lang.title_label}</label>
              <input type="text" className="form-control form-control-sm" name="Title" value={dataItem.Title} onChange={onChange} required />
            </div>
            {showLanguage && <div className="col-5">
              <label htmlFor="">{lang.language_label}</label>
              <MultiSelect
                data={languages}
                dataItemKey="_id"
                textField="Description"
                value={dataItem.Languages}
                onChange={onChange}
                name={"Languages"}
              />
            </div>}
            <ActionButton style={{ marginTop: "20px", height: "30px" }} btnColor={'primary'} title={lang.show_button_tooltip} name={"Show"} onClick={() => generateData(dataItem.Title, true)} />
          </div>


          <div className='row'>
            {isLoading ?
              <Loader height="450px" description={props.description} bossAI={true} /> :
              <>
                <ResponseTable onClose={() => setShowMetaData(false)} value={data} popup={false} height="400px" />
                <DialogActionsBar >
                  <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                    onClick={onConfirm}
                  >
                    {lang.confirm_button_text}
                  </button>
                  <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                    onClick={onCloseForm}
                  >
                    {lang.cancel_button_text}
                  </button>
                </DialogActionsBar>
              </>
            }
          </div>


        </BossDialog>
      }
    </div>
  )
}

export default BossAssistantIcon